import { render, staticRenderFns } from "./PagarComissaoDialog.vue?vue&type=template&id=8b178ed0&"
import script from "./PagarComissaoDialog.vue?vue&type=script&lang=js&"
export * from "./PagarComissaoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports